<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('account.addAccount') }}
      </div>
    </div>
    <div
      v-if="loading"
      class="wrap_box warp1"
    />
    <div
      v-else-if="empty"
      class="wrap_box warp1"
    >
      <van-empty :description="$t('account.noWalletTypes')" />
    </div>
    <div
      v-else
      class="wrap_box warp1"
    >
      <div class="item">
        <div class="ari_font">
          {{ $t('account.bank') }}：
        </div>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="value"
            :options="wallets"
            @change="onChange()"
          />
        </van-dropdown-menu>
      </div>
      <!-- 虚拟货币 -->
      <div v-show="bank.type != 4">
        <div class="item">
          <div class="ari_font">
            {{ $t('account.address') }}：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            :placeholder="$t('account.addressTit')"
          >
        </div>
      </div>
			
      <!-- 银行卡 -->
      <div v-show="bank.type == 4">
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.bank') }}：
          </div>
          <input
            v-model="bank.area"
            class="card"
            type="text"
            :placeholder="$t('invest_bank.bankin')"
          >
        </div>
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.name') }}：
          </div>
          <input
            v-model="bank.name"
            class="card"
            type="text"
            :placeholder="$t('invest_bank.namein')"
          >
        </div>
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.account') }}：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            :placeholder="$t('invest_bank.accountin')"
          >
        </div>
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.cci') }}：
          </div>
          <input
            v-model="bank.cci"
            class="card"
            type="text"
            inputmode="numeric"
            maxlength="20"
            :placeholder="$t('invest_bank.cciin')"
          >
        </div>
      </div>
      <div class="qrcode">
        <div>{{ $t('account.qrcodetips') }}</div>
        <div class="qrcode_img">
          <van-uploader
            v-model="fileList"
            class="upload"
            :max-count="1"
            :max-size="2 * 1024 * 1024"
            accept="image/jpeg,image/png"
            :disabled="uploading || submitting"
            :before-read="beforeRead"
            :after-read="afterRead"
            @oversize="onOversize"
            @delete="onDelete"
          />
        </div>
      </div>
    </div>
    <div
      v-if="!loading && !empty"
      class="basic_btn"
      :class="{ disabled: submitting || uploading }"
      @click="submitBtn"
    >
      {{ $t('account.submit') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        Overlay,Uploader,Button,DropdownMenu, DropdownItem, Empty
    } from 'vant';

    Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem).use(Empty);
    export default {
        name: "AddcountUsdt",
        data() {
            return {
                bank: {
                    account: '',
					name:'',
                    area: '',
					cci: '',
                    bank:'',
					img:'',
					type:1,
					wid:0
                },
				fileList: [],
				type:1,
				value:0,
				wallets:[],
				loading: true,
				empty: false,
				submitting: false,
				uploading: false
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			start(){
				this.loading = true;
				this.empty = false;
				Fetch('/user/wallet_type',{
				}).then(r=>{
					const list = Array.isArray(r.data) ? r.data : [];
					this.empty = list.length === 0;
					this.wallets = [];
					for (let i = 0; i < list.length; i++) {
						this.wallets.push({
							text: list[i].name,
							value: i,
							type:list[i].type,
							wid:list[i].id
						})
					}
					if (!this.empty) this.onChange();
				}).catch(() => {
					this.empty = true;
				}).finally(() => {
					this.loading = false;
				})
			},
            submitBtn(){
				if (this.submitting || this.uploading) return;
				if (!this.bank.account.trim()) {
					this.$notify(this.$t('account.addressEmpty'));
					return;
				}
				if (this.bank.type === 4 && (!this.bank.area.trim() || !this.bank.name.trim())) {
					this.$notify(this.$t('account.bankFieldsRequired'));
					return;
				}
				if (this.bank.type === 4 && this.bank.cci && !/^\d{20}$/.test(this.bank.cci)) {
					this.$notify(this.$t('invest_bank.cciinvalid'));
					return;
				}
				this.submitting = true;
                Fetch('/user/bank_add',{
					account: this.bank.account.trim(),
					name: this.bank.name.trim(),
					area: this.bank.area.trim(),
					cci: this.bank.cci.trim(),
					wid: this.bank.wid,
					img: this.bank.img
				}).then(()=>{
					this.$router.go(-1);
				}).finally(() => {
					this.submitting = false;
				})
            },
			onChange(){
				const wallet = this.wallets[this.value];
				if (!wallet) return;
				this.bank.account = '';
				this.bank.name = '';
				this.bank.area = '';
				this.bank.cci = '';
				this.bank.bank = wallet.text;
				this.bank.type = wallet.type;
				this.bank.wid = wallet.wid;
			},
			beforeRead(file) {
				const type = (file.type || '').toLowerCase();
				const name = (file.name || '').toLowerCase();
				if (['image/jpeg', 'image/png'].indexOf(type) === -1 || !/\.(jpe?g|png)$/.test(name)) {
					this.$notify(this.$t('account.supportPicture'));
					return false;
				}
				return true;
			},
			onOversize() {
				this.$notify(this.$t('account.within2megabytes'));
			},
			onDelete() {
				this.bank.img = '';
			},
			afterRead(file) {
				if (!file || !file.file) return;
				this.uploading = true;
				file.status = 'uploading';
				file.message = this.$t('utils.loading');
				const formData = new FormData();
				formData.append('file', file.file);
				Fetch('/user/bank_qrcode_upload', formData).then((response) => {
					const url = response && response.data ? response.data.url : '';
					if (!url) throw new Error('upload failed');
					this.bank.img = url;
					file.status = 'done';
					file.url = url;
					this.$notify(this.$t('account.uploadSuccess'));
				}).catch(() => {
					this.bank.img = '';
					file.status = 'failed';
					file.message = this.$t('account.uploadFail');
				}).finally(() => {
					this.uploading = false;
				});
			}
            
        }
    };
</script>

<style lang="less" scoped>
	// /deep/ .van-overlay{
	// 	background-color:hsla(0,0%,100%,0);
	// }
 //    /deep/ .van-dropdown-menu {
 //        position: relative;
	// 	width: 100%;
 //        z-index: 10;
 //        color: #CCCCCC;
 //    }

    /deep/ .van-dropdown-menu__bar {
		box-shadow:none;
        // position: relative;
        // z-index: 10;
        // height: 34px;
        // border: 1px solid #D9D9D9;
        // border-radius: 4px;
        // text-align: left;
    }
 //    /deep/ .van-dropdown-item--down {
 //        margin: 0 auto;
 //        z-index: 12;
 //        transform: translateX(4px);
 //    }

    // /deep/ .van-dropdown-menu__item {
    //     justify-content: flex-start;
    //     color: #ccc;
    //     background-color: #fff;
    // }

 //    /deep/ .van-dropdown-menu__title {
 //        width: 100%;
 //    }

 //    /deep/ .van-dropdown-menu__title::after {
 //        width: 13px;
 //        height: 22px;
 //        transform: none;
 //        background: url(../../assets/images/drop.png) no-repeat center center;
 //        background-size: 100% 100%;
 //        border: none;
 //        opacity: 1;
 //        margin-top: -11px;
 //        right: 10px;
 //    }

 //    /deep/ .van-cell {
 //        padding: 5px 8px;
 //    }

 //    /deep/ .van-cell__title {
 //        flex: 3;
 //        white-space: normal;
 //    }

 //    /deep/ .van-ellipsis {
 //        color: #000;
 //    }

 //    /deep/ .van-dropdown-item__option {
 //        color: #ccc;
 //        border: 1px solid #D9D9D9;
 //        border-bottom: none;
 //        border-radius: 4px;
 //    }

 //    /deep/ .van-dropdown-item__option:last-child {
 //        border-bottom: 1px solid #D9D9D9;
 //    }

 //    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
 //        color: #000;

 //        .van-dropdown-item__icon {
 //            color: #E96259;
 //        }
 //    }
	/deep/ .van-button--primary {
		background-color: transparent;
		border: none;
		width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__input-wrapper {
		width: 100%;
	}
	/deep/ .van-uploader__wrapper{
		width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__upload{
		width: 100%;
		height: 100%;
		margin:0;
	}
	/deep/ .van-uploader__preview{
		margin:0;
	}
	/deep/ .van-uploader__preview-image{
		width: 100%;
		height: 100%;
	}
	
    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
		margin: 10px;
        margin-top: 12px;
        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }
			.card{
				width: 100%;
			}
            input {
                line-height: 14px;
            }
        }
    }

    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 75px auto 0 auto;
    }
	.qrcode{
		padding-top: 30px;
		padding-bottom: 30px;
		text-align: center;
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 20px;
		}
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 250px;
			height: 250px;
			margin: 0 auto;
			background: linear-gradient(to left, #999, #999) left top no-repeat, 
						linear-gradient(to bottom, #999, #999) left top no-repeat, 
						linear-gradient(to left, #999, #999) right top no-repeat,
						linear-gradient(to bottom, #999, #999) right top no-repeat, 
						linear-gradient(to left, #999, #999) left bottom no-repeat,
						linear-gradient(to bottom, #999, #999) left bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
			span{
				line-height: 220px;
			}
			img{
				width: 240px;
				height: 240px;
				position: relative;
				top: -255px;
			}
		}
	}
	::placeholder {
		color: #727d91 !important; /* 设置你想要的颜色 */
	}
	
	/deep/ .van-dropdown-menu__title::after {
		width: 8px;
		height: 8px;
		border-color: transparent transparent #727d91 #727d91;
		right: -18px;
		margin-top: -10px;
	}
	/deep/ .van-dropdown-menu__title--down::after {
		margin-top: -1px !important;
		-webkit-transform: rotate(135deg);
		transform: rotate(135deg);
	}
	/deep/ .van-dropdown-menu__bar{
		background-color: transparent;
	}
	/deep/ .van-dropdown-item--down{
		margin: 0 10px;
	}
	/deep/ .van-dropdown-item__option--active{
		color: #fff;
	}
	/deep/ .van-dropdown-item__option--active .van-dropdown-item__icon{
		color: #fff;
	}
	/deep/ .van-cell{
		background-color: #727d91;
	}

	.recharge_wrap { min-height: 100vh; background: #f5f5f5; padding-bottom: calc(var(--app-bottom-menu-height) + 24px + env(safe-area-inset-bottom, 0px)); }
	.red_top_bg { height: 50px; position: relative; background: #fff; border-bottom: 1px solid #eee; }
	.back_left { filter: brightness(0); opacity: 1; }
	.big_tit { top: 13px; color: #333; font-size: 16px; font-weight: 500; }
	.warp1 { margin: 10px 0 0; background: #fff; }
	.warp1 .item { height: 54px; padding: 0 16px; }
	.ari_font { color: #555; font-size: 13px; font-weight: 400; }
	.warp1 .item input { color: #333; font-size: 14px; }
	.basic_btn { width: calc(100% - 32px); height: 42px; margin: 24px auto 0; border-radius: 4px; background: #ee4d2d; color: #fff; line-height: 42px; }
	.basic_btn.disabled { opacity: .55; pointer-events: none; }
	::placeholder { color: #aaa !important; }
	.warp1 { border-radius: 0; box-shadow: none; }
	.warp1 .item { min-height: 56px; height: auto; border-color: #ededed; }
	.warp1 .item input { height: 40px; min-width: 0; border: 0; background: transparent; }
	/deep/ .van-dropdown-menu__title { color: #333; font-size: 14px; }
	/deep/ .van-dropdown-item__content { border-radius: 0 0 6px 6px; box-shadow: 0 8px 18px rgba(0, 0, 0, .1); }
	/deep/ .van-cell { background: #fff; color: #333; }
	/deep/ .van-dropdown-item__option--active,
	/deep/ .van-dropdown-item__option--active .van-dropdown-item__icon { color: #ee4d2d; }
</style>
